import { Fragment } from 'react';
import { getRandomArrayElement } from '~/shared';

export const messagesWithKiller = [
	'Вы были избиты злобными детьми на детской площадке, но самый главный второклашка оказался {killer_nickname}, который забил вас фигуркой для песка...',
	'Смертельный теннисный матч, где {killer_nickname} использовал вас вместо мяча',
];

export const messagesWithoutKiller = [
	'Неудачный день для существования',
	'Вы проиграли в лотерею невезения',
];

export const generateDeathMessage = (killerNickname?: string | null) => {
	let messageTemplates;
	let message;
	let parsedMessage;

	if (killerNickname) {
		messageTemplates = messagesWithKiller;
		message = getRandomArrayElement(messageTemplates);

		parsedMessage = (
			<Fragment>
				{message?.split('{killer_nickname}').map((part, index) =>
					index === 0 ? (
						part
					) : (
						<Fragment key={index}>
							<span key={index} style={{ color: '#FFFFFF' }}>
								{killerNickname}
							</span>
							{part}
						</Fragment>
					),
				)}
			</Fragment>
		);
	} else {
		messageTemplates = messagesWithoutKiller;
		message = getRandomArrayElement(messageTemplates);

		parsedMessage = <Fragment>{message}</Fragment>;
	}

	return parsedMessage;
};
